import { render, staticRenderFns } from "./MyMindset.vue?vue&type=template&id=218fdd0e"
import script from "./MyMindset.vue?vue&type=script&lang=js"
export * from "./MyMindset.vue?vue&type=script&lang=js"
import style0 from "./MyMindset.vue?vue&type=style&index=0&id=218fdd0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports